import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "ngx-flusso-field",
  templateUrl: "./flusso-field.component.html",
  styleUrls: ["./flusso-field.component.scss"],
})
export class FlussoFieldComponent implements OnInit {
  @Input() field: any = {};
  @Output() update = new EventEmitter();
  validations: any[] = [];

  constructor() {}

  ngOnInit() {
    if (!this.field.step) {
      this.field.step = 1;
    }

    if (this.field.validation) {
      Object.keys(this.field.validation).map((k) => {
        this.validations.push({
          type: k,
          value: this.field.validation[k],
        });
      });
    }
  }

  updateData() {
    this.update.emit(this.field);
    console.log(this.field);
  }

  addOption() {
    if (this.field.options) {
      this.field.options.push({ label: "", value: "" });
    } else {
      this.field.options = [{ label: "", value: "" }];
    }
  }

  removeOption(i) {
    this.field.options.splice(i, 1);
  }

  addValidation() {
    let blankVal = { type: "", value: "" };
    this.validations.push(blankVal);
    this.updateValidation();
  }

  updateOption(option, index) {
    this.field.options[index] = option;
    this.updateData();
  }

  updateValidation() {
    this.field.validation = {};
    console.log("VALIDATIONS",this.validations)
    this.validations.map((v) => {
      this.field.validation[v.type] = v.value || true;
    });

    this.updateData();
  }

  removeValidation(i) {
    this.validations.splice(i, 1);
    this.updateValidation();
  }
}
